import React from 'react';
import { Button } from './ui/Button';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-gray-50 py-10 px-4 md:px-8" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-[#16a34a]" data-id="element-129">
          <div className="bg-[#16a34a] py-3 text-center" data-id="element-130">
            <h2 className="text-white font-bold text-2xl uppercase tracking-wider" data-id="element-131">
              🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
            </h2>
          </div>

          <div className="p-6 md:p-8 text-center" data-id="element-132">
            <h3 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-133">
              KIT COMPLETO PRIMARIA LISTA
            </h3>

            <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-134">
              {['Acceso de por vida', 'Descarga inmediata', 'Garantía 7 días', '2 Bonos incluidos'].map((item, i) => <span key={i} className="bg-green-50 text-green-800 text-sm font-bold px-3 py-1 rounded-full" data-id="element-135">
                  ✔ {item}
                </span>)}
            </div>

            <div className="mb-6" data-id="element-136">
              <p className="text-gray-500 text-lg mb-1" data-id="element-137">
                Precio regular{' '}
                <span className="line-through text-red-500 decoration-2" data-id="element-138">
                  $49.990 ARS
                </span>
              </p>
              <p className="text-5xl md:text-6xl font-black text-[#16a34a]" data-id="element-139">
                HOY $19.990 ARS
              </p>
              <p className="text-gray-600 mt-1 font-medium" data-id="element-140">
                Pago único · En pesos argentinos
              </p>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-141">
              <a href="https://mi-tienda-pro-8012.myshopify.com/cart/48041308586203:1" className="w-full max-w-md" data-id="element-142">
                <Button fullWidth pulse className="text-xl md:text-2xl py-5" data-id="element-143">
                  👉 SÍ, QUIERO EL KIT COMPLETO
                </Button>
              </a>

              <div className="mt-4" data-id="element-144">
                <p className="text-sm text-gray-600 font-bold mb-2 uppercase tracking-wide" data-id="element-145">
                  Métodos de pago seguros:
                </p>
                <div className="flex flex-wrap justify-center gap-2" data-id="element-146">
                  {['MERCADO PAGO', 'VISA', 'MASTERCARD', 'TRANSFERENCIA'].map((method, i) => <span key={i} className="bg-gray-100 text-gray-700 px-3 py-1 rounded border border-gray-200 text-xs font-bold" data-id="element-147">
                        {method}
                      </span>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}